export default {
  template: '#upsell_item',
  created: function() {
    this.$on('campaign-end-date-changed', function(date) {
      if (this.upsell.type == 'CAMPAIGN')
        this.verifyDates();
    });

    this.$on('design-ready', function() {
      this.mainProductDesign = this.getMainProductDesign();
    });

    this.mainProductDesign = this.getMainProductDesign();
  },
  watch: {
    'campaignUpsell.discount': {
      handler: 'watchDiscount'
    },
    'campaignUpsell.upsellType': {
      handler: 'parseDiscount'
    },
    'campaignUpsell': {
      deep: true,
      handler: 'watchUpsellChanges'
    }
  },
  events: {
    'selling_price_updated': function() {
      this.watchDiscount(this.campaignUpsell.discount);
    }
  },
  ready: function() {
    if (this.upsell.type == 'CAMPAIGN') {
      this.setupGroupedProducts();
      this.verifyDates();
    }
    this.setupUpsellData();
  },
  data: function() {
    return {
      groupedProducts: [],
      products: [],
      discount_status: false,
      discount_message: '',
      activeProducts: [],
      campaignUpsell: {
        campaignId: '',
        currentProduct: '',
        currentColor: '',
        currentSide: 'FRONT',
        discount: 0.00,
        upsellType: '$',
        campaignProductId: ''
      },
      updateEndDate: false,
      mainProductDesign: ''
    }
  },
  filters: {
    userTimezone: function(val) {
      return this.$root.formatDate(val);
    }
  },
  methods: {
    getMainProductDesign: function() {
      if (this.isSublimationProduct()) {
        if (this.$root.designerItems.front.length > 0)
          return this.$root.designerItems.front[0].imageData['original_url'];
        else
          return '';
      } else {
        return this.$root.campaignData.design.front.upscaled;
      }
    },
    setupUpsellData: function() {
      if (this.upsell.type == 'CAMPAIGN')
        this.$set('campaignUpsell.campaignId', this.upsell.campaign.id);
      else
        this.$set('campaignUpsell.campaignId', 'SELF');
    },
    setupGroupedProducts: function() {
      var campaignProducts = this.upsell.products,
        activeProducts = _.filter(campaignProducts, function(product) {
          return product.active == 1;
        }),
        groupedProducts = _.groupBy(activeProducts, function(product) {
          return product.product_id;
        }),
        products = [];

      _.each(groupedProducts, function(group) {
        var product = group[0];
        products.push({
          text: product.product.name,
          value: product.product_id
        })
      });

      this.$set('products', products);
      this.$set('groupedProducts', groupedProducts);
      this.$set('activeProducts', activeProducts);
      this.$set('campaignUpsell.currentProduct', products[0].value);
    },
    verifyDates: function() {
      var mainCampaignDate = moment(this.$root.campaignData.campaign_end_date_obj),
        upsellCampaignDate = moment(this.upsell.campaign.end_date);

      this.$set('updateEndDate', upsellCampaignDate.isBefore(mainCampaignDate));
    },
    watchUpsellChanges: function() {
      var campaignUpsells = this.$root.campaignData.campaign_upsells,
        campaignUpsellIdx = -1,
        campaignUpsellData = this.campaignUpsell,
        that = this;

      campaignUpsellData['type'] = this.upsell.type;

      if (this.upsell.type == 'SELF') {
        campaignUpsellIdx = _.findIndex(campaignUpsells, function(upsell) {
          return upsell.type == 'SELF';
        });
      } else {
        var campaignUpsellId = this.upsell.campaign.id;
        campaignUpsellIdx = _.findIndex(campaignUpsells, function(upsell) {
          return upsell.campaignId == campaignUpsellId;
        });

        var campaignProduct = _.find(this.activeProducts, function(product) {
          return (product.product_id == that.campaignUpsell.currentProduct && product.colors == that.campaignUpsell.currentColor);
        });

        campaignUpsellData['campaignProductId'] = campaignProduct.id;
      }
      if (campaignUpsellIdx != -1)
        this.$root.campaignData.campaign_upsells[campaignUpsellIdx] = campaignUpsellData;
      else
        this.$root.campaignData.campaign_upsells.push(campaignUpsellData);
    },
    parseDiscount: function() {
      if (this.campaignUpsell.upsellType == '$') {
        if (this.campaignUpsell.discount == '')
          this.campaignUpsell.discount = 0.00;
        else
          this.campaignUpsell.discount = parseFloat(this.campaignUpsell.discount).toFixed(2);
      } else {
        if (this.campaignUpsell.discount == '')
          this.campaignUpsell.discount = 0;
        else
          this.campaignUpsell.discount = parseFloat(this.campaignUpsell.discount);
      }
    },
    watchDiscount: function(val) {
      var that = this,
        discount = parseFloat(val);
      that.$set('discount_status', false);
      that.$set('discount_message', '');
      if (this.upsell.type == 'CAMPAIGN') {
        _.each(this.upsell.products, function(product) {
          var sellingPrice = parseFloat(product.selling_price),
            basePrice = parseFloat(product.cost_price);

          if (that.campaignUpsell.upsellType == '%') {
            discount = sellingPrice * (discount * 0.01);
          }

          if ((sellingPrice - discount) < basePrice) {
            that.$set('discount_status', true);
            that.$set('discount_message', 'Discount is greater than minimum profit margin of campaign product');
            return false;
          }
        });
      } else {

        // ADDITIONAL PRODUCTS

        if (this.$root.campaignData.additionalProducts.length) {
          _.each(this.$root.campaignData.additionalProducts, function(product) {
            if (that.campaignUpsell.upsellType == '%') {
              discount = product.selling_price * (discount * 0.01);
            }

            if (discount > (product.selling_price - product.dtg_price)) {
              that.$set('discount_status', true);
              that.$set('discount_message', 'Discount is greater than minimum profit margin of an additional product')
              return false;
            }
          })
        }
        // MAIN PRODUCT
        var basePrice = parseFloat(this.$root.campaignData.pricing.dtgPrice),
          sellingPrice = parseFloat(this.$root.campaignData.pricing.sellingPrice);

        if (this.campaignUpsell.upsellType == '%') {
          discount = sellingPrice * (discount * 0.01);
        }

        if ((sellingPrice - discount) < basePrice) {
          that.$set('discount_status', true);
          that.$set('discount_message', 'Discount is greater than minimum profit margin of main product');
          return false;
        }

        // END MAIN PRODUCT

      }
    },
    removeUpsell: function() {
      this.$dispatch('upsell-removed', this.upsell.type == 'CAMPAIGN' ? this.upsell.campaign.id : 'SELF');
    },
    getCurrentCampaignThumbnail: function() {
      if (this.isSublimationProduct()) {
        return this.$root.preview.front.large;
      } else {
        return this.$root.getDesignerHelper().imagePath + this.$root.selectedProduct.image.front.original;
      }
    },
    getDesignCSS: function() {
      if (this.$root.campaignData.mainProduct.product.product) {
        var selectedProduct = this.$root.campaignData.mainProduct.product.product,
          mainProductHeight = selectedProduct.front_image_height,
          designContainerHeight = selectedProduct.front_height,
          mainProductTop = selectedProduct.front_top,
          mainProductLeft = selectedProduct.front_left,
          calculatedHeightRatio = parseFloat(mainProductHeight) / 180;

        return {
          top: mainProductTop / calculatedHeightRatio + 'px',
          left: mainProductLeft / calculatedHeightRatio + 'px',
          position: 'absolute',
          height: designContainerHeight / calculatedHeightRatio + 'px'
        };
      } else {
        return {
          top: '0px',
          left: '0px',
          position: 'absolute',
          height: '0px'
        }
      }
    },
    getMainProductColor: function() {
      return { 'background-color': this.$root.campaignData.mainProduct.currentColor.hex };
    },
    isSublimationProduct: function() {
      return this.$root.isSublimationProduct();
    }
  },
  computed: {
    colors: function() {
      var that = this;
      if (Object.keys(this.groupedProducts).length > 0) {
        var selectedProducts = _.find(this.groupedProducts, function(group, i) {
          return i == that.campaignUpsell.currentProduct;
        });

        var colors = [];
        _.each(selectedProducts, function(product) {
          var color = product.color;
          colors.push({
            text: color.name,
            value: color.id
          });
        });

        this.campaignUpsell.currentColor = colors[0].value;
        return colors;
      } else {
        return [];
      }
    }
  }
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/launch_tab/upsellItem.js